import { Box, Typography } from "@mui/material";

interface ResumoCardProps {
  value: number | string;
  label: string;
  colorPrimary: string;
  colorSubText: string;
  navigation?: () => void;
}

export function ResumoCard({
  value,
  label,
  colorPrimary,
  colorSubText,
  navigation,
}: ResumoCardProps) {
  return (
    <Box
    onClick={navigation}
      sx={{
        minHeight: 140,
        width: "100%",
        maxWidth: 220,
        borderRadius: 2,
        backgroundColor: "#fff",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        cursor: "default",
        transition: "all 0.3s ease",
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",

        "&:hover": {
          transform: "translateY(-4px) scale(1.02)",
          boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
        },
      }}
    >
      <Typography
        fontWeight={700}
        fontSize="2.5rem"
        color={colorPrimary}
      >
        {value}
      </Typography>

      <Typography
        fontWeight={600}
        fontSize="0.9rem"
        color={colorSubText}
        letterSpacing={0.8}
      >
        {label.toUpperCase()}
      </Typography>
    </Box>
  );
}
